/**
 * enum의 value를 입력받아 해당 enum의 key를 리턴한다.
 * @param {Object} T enum object
 * @param {*} value 찾을 value
 * @param {string} defaultName 못 찾았을 때 반환할 문자열
 * @return {string}
 */
export const getTypeName = (T, value, defaultName) => {
  console.assert(typeof T === 'object', {
    message: 'T는 enum object이어야 한다.',
  });

  const name = Object.keys(T).find((key) => T[key] == value);
  return name ?? defaultName;
};

export const mediaType = {
  unknown: 'unknown',
  image: 'image',
  video: 'video',
};

const mediaExtensions = {
  image: ['png', 'jpg', 'jpeg', 'gif', 'svg', 'webp'],
  video: ['mp4', 'mov', 'webm'],
};

export const getMediaType = (extension) => {
  if (mediaExtensions.image.some((e) => e === extension)) {
    return mediaType.image;
  }
  if (mediaExtensions.video.some((e) => e === extension)) {
    return mediaType.video;
  }
  return mediaType.unknown;
};
